export const BENEFITS_COPY = {
  HEADER: 'Stay focused at work while we help you at home',
  DISCLAIMER:
    'Specific employer benefits may vary. Enroll now to discover the employer benefits available to you.',
};

export const ENROLLMENT_CTA_TEXT = 'Join now';
